import { useSearchParams } from "react-router-dom";
import { useFetch } from "@/lib/api";
import { CATEGORIES } from "@/lib/format";
import { PageHeader, Loader, Empty } from "@/components/common";
import { EventCard } from "@/components/EventCard";

export default function Events() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "tous";
  const { data, loading } = useFetch(`/events?category=${cat}`, [cat]);

  return (
    <div data-testid="events-page" className="pb-32 md:pb-16">
      <PageHeader title="Nos prochains Instants" subtitle="Soirées, rencontres et dégustations d'exception." />
      <div data-testid="filters-marquee" className="marquee overflow-hidden pb-5">
        <div className="marquee-track flex w-max gap-2">
          {[0, 1].map((copy) => CATEGORIES.map((c) => (
            <button key={`${copy}-${c.key}`} data-testid={copy ? `filter-${c.key}-dup` : `filter-${c.key}`} aria-hidden={copy ? true : undefined} tabIndex={copy ? -1 : 0} data-copy={copy || undefined}
              onClick={() => setParams(c.key === "tous" ? {} : { cat: c.key })}
              className={`shrink-0 rounded-full border px-4 py-2 text-xs font-semibold transition-colors duration-200 ${cat === c.key ? "border-transparent bg-[linear-gradient(100deg,#E6A45D,#F8C872,#F6D7A1)] text-[#1D140B]" : "border-[#E6A45D]/40 text-[#F6D7A1] hover:bg-[#1D140B]"}`}>
              {c.label}
            </button>
          )))}
        </div>
      </div>
      {loading ? <Loader /> : data?.length ? (
        <div data-testid="events-list" className="grid gap-5 px-5 md:grid-cols-2 lg:grid-cols-3">{data.map((e, i) => <EventCard key={e.id} e={e} i={i} />)}</div>
      ) : <Empty testid="events-empty" text="Aucun événement à venir dans cette catégorie pour le moment." />}
    </div>
  );
}
